import { AbstractPmsApiService } from "./abstract.service";
import { Country } from "../models";

/**
 * @class CountryPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Country>}
 */
export class CountryPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/country(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Country}
     * @protected
     */
    newModel(attributes) {

        return new Country(attributes);
    }

    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<Country>>}
     */
    get (params = {}) {

        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {Country} country
     * @returns {Promise.<Country>}
     */
    create(country) {

        const url = this.url();

        return this.http
                   .post(url, country, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {Country} country
     * @returns {Promise.<Country>}
     */
    update(country) {

        const url = this.url({id: country.id});

        return this.http
                   .put(url, country, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {Country} country
     * @returns {Promise.<boolean>}
     */
    delete(country) {

        const url = this.url({id: country.id});

        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }

    getCurrenciesSuper(params) {

        const url = `${this.url()}/currency`;

        params.language = params.language ? params.language.toUpperCase() : null;

        return this.http
                .get(url, {
                    headers: this.authHeaders,
                    params,
                    ignoreLoadingBar: true
                })
                .then(this.getMassModeler());
    }

    getCurrencies(params) {

        return this.getCurrenciesSuper(params)
                .then(response => [...new Set(response.map(country => params.language === 'AR' ? country.currency_ar : country.currency))])
                .catch(this.getErrorHandler());
    }

    getCurrenciesAll(params) {

        const exist = new Set();

        return this.getCurrenciesSuper(params)
                .then(response => response
                    .filter(response => {

                        if (exist.has(response.currency)) {
                            return false;
                        };

                        exist.add(response.currency);
                        return true;
                    })
                    .map(({currency, currency_ar}) => ({currency, currency_ar})))
                .catch(this.getErrorHandler());
    }

    /**

     * @param {Integer} countryId
     * @param {Object} params
     */
    show(countryId, params = {}) {

        const url = this.url({
            id: countryId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    canDelete(country) {

        const url = this.url({
            id: country.id
        }) + '/can-delete';

        return this.http
            .get(url, {
                headers: this.authHeaders,
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/country.service.js